import { skipToastOperations } from "@lon/shared/constants";

export const skipOperationToast = (operationName: string) =>
  skipToastOperations.some((operation) => operation === operationName);
